
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"79","height":"79"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Rectángulo 26","fill":"none","d":"M0 0h79v79H0z"}}),_c('g',{attrs:{"fill":"#6c757d"}},[_c('path',{attrs:{"data-name":"Trazado 5","d":"M55.556 17H33.333a4.449 4.449 0 00-4.444 4.444v13.334h-4.445A4.449 4.449 0 0020 39.222v20a2.222 2.222 0 002.222 2.222h35.556A2.222 2.222 0 0060 59.222V21.444A4.449 4.449 0 0055.556 17zM24.444 39.222h13.334V57H24.444zM55.556 57H42.222V39.222a4.449 4.449 0 00-4.444-4.444h-4.445V21.444h22.223z"}}),_c('path',{attrs:{"data-name":"Trazado 6","d":"M38.16 23.977h3.68v5.4h-3.68zm7.36 0h3.68v5.4h-3.68zm0 10.884h3.68v5.316h-3.68zm0 10.716h3.68v5.4h-3.68zm-14.72 0h3.68v5.4H30.8z"}})])])
          )
        }
      }
    